import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const HERO_IMG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_painting-prints--3pphcjo7/artifacts/18fe16b393ae9f0a_IMG_2037.JPG";

export default function HomePage() {
  const linkClass =
    "font-mono-accent text-xs sm:text-sm uppercase tracking-[0.3em] text-[#C9501C] hover:text-[#2A2118] transition-colors duration-300 underline-offset-8 hover:underline";

  return (
    <div data-testid="home-page" className="relative min-h-screen overflow-hidden">
      {/* Background */}
      <motion.img
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        src={HERO_IMG}
        alt="mads i studiet"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ filter: "sepia(0.42) brightness(1.08) saturate(1.12)" }}
      />
      <div className="absolute inset-0 bg-[#F5E8D0]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#F5E8D0] via-transparent to-[#F5E8D0]/50" />

      {/* Center content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif-display italic text-6xl sm:text-7xl lg:text-8xl tracking-tight text-[#2A2118] drop-shadow-sm"
          data-testid="hero-heading"
        >
          mads<span className="not-italic text-[#C9501C]">.</span>
        </motion.h1>

        <motion.nav
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 flex flex-col items-center gap-5"
          data-testid="hero-nav"
        >
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            <Link to="/collections/everybody-looks" data-testid="hero-collection-button" className={linkClass}>
              Everybody Looks
            </Link>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            <Link to="/special" data-testid="hero-special-button" className={linkClass}>
              Special
            </Link>
            <Link to="/contact" data-testid="hero-contact-button" className={linkClass}>
              Contact
            </Link>
          </div>
          <a
            href="https://www.instagram.com/madsmade47/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-instagram-button"
            className={linkClass}
          >
            Instagram
          </a>
        </motion.nav>
      </div>
    </div>
  );
}
